import React, { useEffect, useState } from "react";
import DeletePops from "../../../Pops/DeletePops";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import {
  LinearProgress,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { AddButton } from "../../../Button/AddButton";
import { setOpen } from "../../../../Redux/ModalReducer";
import DeleteModal from "../DeleteModal";
import DataTable from "../data-table";
import {Can} from "../../../Can";

const SkypeGroupTable = () => {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedKeyword(keyword);
      setCurrentPage(1);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [keyword]);

  useEffect(() => {
    if (shouldRefresh) {
      setCurrentPage(1);
      setShouldRefresh(false);
    }
  }, [shouldRefresh]);

  useEffect(() => {
    setIsLoading(true);
    setData();
    getData();
  }, [currentPage, debouncedKeyword]);

  const getData = async () => {
    const { response, message } = await Helper.Get({
      url:
        api_Routes.Groups.Skype.View +
        "?page=" +
        currentPage +
        "&keyword=" +
        keyword,
      hasToken: true,
    });
    if (response) {
      setData(response);
    }
    setIsLoading(false);
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleShow = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  return (
    <div>
      <div className="flex flex-col-reverse justify-between items-center gap-4 mb-3 md:flex-row">
        <label className="font-bold inline-block text-textColor dark:text-darkTextColor text-[15px]  text-start">
          Search :
          <input
            placeholder="Write any keyword"
            type="text"
            name="keyword"
            value={keyword}
            onChange={handleKeywordChange}
            autoComplete="off"
            className="duration-200 font-normal bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor ml-2
                           border-2 input-box 
                           rounded-[0.25rem]  py-1 px-3 outline-none"
          />
        </label>

        <Can I="store" a="skypeGroups">
        <AddButton to="/AddSkypeGroups" label="Add Skype Group" />
        </Can>
      </div>
      <DeletePops />
      {loading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data?.data?.length > 0 ? (
        <>
          <DeleteModal
            show={show}
            handleClose={handleClose}
            selectedId={selectedId}
            setShouldRefresh={setShouldRefresh}
          />
          <div className="overflow-x-auto">
            <DataTable
              data={data?.data}
              setSelectedId={setSelectedId}
              handleShow={handleShow}
            />
          </div>
          <div className="mt-4 flex justify-center items-center">
            <Pagination
              page={currentPage}
              className="mt-auto"
              onChange={handlePageChange}
              count={data?.pagination?.total_pages}
              variant="outlined"
              shape="rounded"
            />
          </div>
        </>
      ) : (
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  There are no data yet
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default SkypeGroupTable;
